// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Ppgp","error":"Textarea_error__CO1k5","readonly":"Textarea_readonly__3KTaQ","disabled":"Textarea_disabled__3b7vG"};